window.cronitor = window.cronitor || function() { (window.cronitor.q = window.cronitor.q || []).push(arguments); };
cronitor('config', { clientKey: '2ff9ef6048050075f1382d6b31d8b1f6' });
console.log('coucou cronitor');